var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBitbucket(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5301_817)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5301_817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.03213 1.45612C0.922536 1.4547 0.81396 1.4773 0.714027 1.52231C0.614093 1.56733 0.525225 1.63367 0.45366 1.71668C0.382096 1.7997 0.32957 1.89737 0.299771 2.00285C0.269973 2.10832 0.263623 2.21904 0.281169 2.32723L3.469 21.6795C3.50872 21.9163 3.63061 22.1316 3.81327 22.2874C3.99592 22.4433 4.22766 22.5299 4.46778 22.5318H19.7611C19.9411 22.5342 20.1159 22.4717 20.2538 22.356C20.3916 22.2402 20.4833 22.0787 20.5121 21.901L23.6999 2.33099C23.7174 2.2228 23.7111 2.11208 23.6813 2.0066C23.6515 1.90113 23.599 1.80345 23.5274 1.72044C23.4558 1.63742 23.367 1.57108 23.267 1.52607C23.1671 1.48105 23.0585 1.45846 22.9489 1.45987L1.03213 1.45612ZM14.4556 15.4428H9.57431L8.25262 8.53768H15.6383L14.4556 15.4428Z",
    fill: "#2684FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6862 8.53809H15.6384L14.4557 15.4432H9.57442L3.81079 22.2844C3.99347 22.4424 4.22638 22.5302 4.46788 22.5322H19.765C19.945 22.5346 20.1198 22.4721 20.2576 22.3564C20.3955 22.2406 20.4871 22.0791 20.5159 21.9014L22.6862 8.53809Z",
    fill: "url(#paint0_linear_5301_817)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5301_817",
    x1: 24.3158,
    y1: 10.4718,
    x2: 12.6684,
    y2: 19.5622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5301_817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5301_817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.4375,
    height: 23.4375,
    fill: "white",
    transform: "translate(0.28125 0.28125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitbucket);
export default __webpack_public_path__ + "static/media/bitbucket.0aa8ea8009536a8e128fd6f924028b87.svg";
export { ForwardRef as ReactComponent };